import React from 'react';

const TrendArrowIcon = () => (
  <svg width="20" height="10" viewBox="0 0 20 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2H19C19.55 2 20 1.55 20 1C20 0.45 19.55 0 19 0H12C11.45 0 11 0.45 11 1C11 1.55 11.45 2 12 2ZM19 8H12C11.45 8 11 8.45 11 9C11 9.55 11.45 10 12 10H19C19.55 10 20 9.55 20 9C20 8.45 19.55 8 19 8ZM19 4H15C14.45 4 14 4.45 14 5C14 5.55 14.45 6 15 6H19C19.55 6 20 5.55 20 5C20 4.45 19.55 4 19 4ZM6.85 0.85C6.7795 0.780897 6.69013 0.734208 6.59314 0.715817C6.49616 0.697426 6.39589 0.708155 6.30499 0.746654C6.2141 0.785153 6.13663 0.849697 6.08235 0.932153C6.02807 1.01461 5.99942 1.11129 6 1.21V4H1C0.45 4 0 4.45 0 5C0 5.55 0.45 6 1 6H6V8.79C6 9.24 6.54 9.46 6.85 9.14L10.64 5.35C10.84 5.15 10.84 4.84 10.64 4.64L6.85 0.85Z" fill="white" />
  </svg>
);

export default TrendArrowIcon;
